enum EWidth {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

export default EWidth;
